import React from 'react';
import { Orbit } from '@uiball/loaders';

import './outletLoader.scss';

const OutletLoader: React.FC = () => {

  return (
    <div className="k-loading-mask outlet-loader">
      <Orbit size={25} speed={1.5} color="black" />
    </div>
  );
};

export default OutletLoader;
